import React from "react";
import { DrawerProps, Drawer, Descriptions } from "antd";
import SVGIcon from "../../../../utils/SVGIcon";
import Config from "../../../../config/Config";
import CancelButton from "../../../../components/Buttons/CancelButton";
import { useAppSelector } from "../../../../utils/hooks/hooks";
import { renderNA } from "../../../../utils/commonFunctions";
import { RootState } from "../../../../store/app";

interface ViewDrawerProps extends DrawerProps {
  titleName: string;
  open: boolean;
  close: () => void;
}

/**
 * Renders a drawer component for viewing details of an interest Discovery result of user.
 *
 * @param {ViewDrawerProps} props - The props object containing the following properties:
 *   - titleName: The name of the title for the drawer.
 *   - open: A boolean indicating whether the drawer is open or not.
 *   - close: A function to close the drawer.
 *   - rest: Any additional props to be spread onto the Drawer component.
 * @return {JSX.Element} The rendered ViewInterestAssessmentDrawer component.
 */
const ViewInterestAssessmentDrawer: React.FC<ViewDrawerProps> = ({
  titleName,
  open,
  close,
  ...rest
}) => {
  const details = useAppSelector(
    (state: RootState) => state.user.interestAssessmentDetail
  );

  const initialAppOption: any = useAppSelector(
    (state: RootState) => state.auth.initialData
  );

  const drawerClose = () => {
    close();
  };

  return (
    <Drawer
      title={`View ${titleName}`}
      open={open}
      placement="right"
      width={"70%"}
      onClose={drawerClose}
      destroyOnClose
      closeIcon={<SVGIcon icon="close" color={Config.themePrimaryBtn} />}
      footer={[<CancelButton key={2} onClick={drawerClose} />]}
      {...rest}
    >
      <Descriptions
        column={1}
        bordered
        layout="horizontal"
        labelStyle={{ width: "18%" }}
      >
        {details ? (
          details?.questions?.map((data: any, index: number) => {
            const answerId = details?.attends.find(
              (answer: any) => answer.question_id === data.id
            )?.answer;
            const answerContent =
              initialAppOption?.interest_assessment_options_type?.find(
                (option: any) => Number(option?.id) === Number(answerId)
              )?.title;
            return (
              <React.Fragment key={`question ${index}`}>
                <Descriptions.Item label={`Question ${index + 1}`}>
                  {renderNA(data?.question)}
                </Descriptions.Item>
                <Descriptions.Item label="Answer">
                  {renderNA(answerContent)}
                </Descriptions.Item>
                {index !== details?.questions?.length - 1 && <br />}
              </React.Fragment>
            );
          })
        ) : (
          <p>User has not attended the test</p>
        )}
      </Descriptions>
    </Drawer>
  );
};

export default ViewInterestAssessmentDrawer;
